/*
$(document).ready(function() {
    $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function() {
      if ($('#agree').is(':checked') && $('#agecheck').is(':checked')) {
        $(this).submit();
      }
      else {
        if (!$('#agree').is(':checked') && !$('#agecheck').is(':checked')) {
          alert("Du skal acceptere handelsbetingelserne og godkende at du er over 18 år for at kunne gå til kassen.");
        }
        else if (!$('#agree').is(':checked')) {
          alert("Du skal acceptere handelsbetingelserne for at kunne gå til kassen.");
        }
        else if (!$('#agecheck').is(':checked')) {
          alert("Du skal godkende at du er over 18 år for at kunne gå til kassen.");
        }
        return false;
      }
    });
});*/

document.addEventListener('DOMContentLoaded', function () {
	var textareas = document.querySelectorAll('.cart-item-property-value-textarea');
	textareas.forEach(function (textareaElement) {
        // Status message handler
        textareaElement.addEventListener('input', () => {
            var msg = textareaElement.parentElement.querySelector(".cart-item-property-status");

            msg.classList.add("show-msg");
        });

        // Save handler
		textareaElement.addEventListener('blur', function () {
			var key = textareaElement.dataset.key;
			var quantity = textareaElement.dataset.quantity;
			var content = $(textareaElement).val();
			var properties = { "modtagerbesked": content }
			jQuery.ajax({
				url: '/cart/change.js',
				type: 'post',
				dataType: 'json',
				data: {
					id: key,
					quantity: quantity,
					properties: properties
				},
				success: function () { window.location = '/cart'; }
			});
		});
	});
});



document.addEventListener("DOMContentLoaded", function() {
  // Find linket baseret på teksten
  const tosLink = document.querySelector('a[href="{{ link }}"]');

  // Tjek om linket eksisterer, og ændr href
  if (tosLink) {
    tosLink.href = "https://delikatessehuset.dk/pages/handelsbetingelser"; // Erstat med den nye URL
  }
});

/*
* FAQ HANDLER
* */

document.addEventListener('DOMContentLoaded', () => {
	const sections = document.querySelectorAll('.faq__section-wrapper');

	sections.forEach((section) => {
		const summaries = section.querySelectorAll('[data-faq-summary]');
		const categories = section.querySelector('.faq__categories');
		const viewAll = section.querySelector('.faq__categories-view-all');

		const closedState = 'closed';
		const openState = 'open';

		// Add event listeners for summary elements
		summaries.forEach((summary) => {
			summary.addEventListener('click', (event) => {
				event.preventDefault();
				const details = summary.closest('[data-faq-details]');
				const answer = summary.nextElementSibling;

				if (details.hasAttribute('open')) {
					closeAccordion(details, answer);
				} else {
					openAccordion(details, answer);
				}
			});
		});

		// Handle view-all toggle
		if (viewAll) {
			viewAll.addEventListener('click', () => {
				viewAll.classList.toggle('faq__categories-view-all--active');
				if (viewAll.classList.contains('faq__categories-view-all--active')) {
					openCategories(categories);
				} else {
					closeCategories(categories);
				}
			});
		}
	});

	function openAccordion(details, answer) {
		details.setAttribute('open', '');
		details.classList.add('faq__details--open');
		answer.style.display = 'block';
		answer.style.height = 'auto';
		answer.style.paddingRight = '1.125rem';
		answer.style.opacity = '1';
	}

	function closeAccordion(details, answer) {
		details.removeAttribute('open');
		details.classList.remove('faq__details--open');
		answer.style.display = 'none';
		answer.style.height = '0';
		answer.style.paddingRight = '0';
		answer.style.opacity = '0';
	}

	function openCategories(categories) {
		const list = categories.querySelector('.faq__categories-list');
		if (list) {
			categories.style.maxHeight = `${list.scrollHeight}px`;
		}
	}

	function closeCategories(categories) {
		categories.style.maxHeight = '0';
	}
});
